export enum TransactionActionEnum {
  NoAction = 0,
  Ok = 1,
  Rest = 2,
  Incorrect = 3,
  Extra = 4,
  NewOcr = 5,
}
